import {
  Box as Flex,
  Chip as Tag,
  Typography as Text,
} from '@material-ui/core';

import { extractLastNameComponent } from '@spotify/confidence-core-react';
import {
  RuleFragment,
  VariantFragment,
  getTypeOrNull,
} from '@spotify/confidence-graphql';

import styles from './VariantItem.module.css';

export const buildVariantUsage = (
  rules: ReadonlyArray<RuleFragment>,
): Record<string, number> => {
  const counts: Record<string, number> = {};
  rules.forEach(rule => {
    rule.assignmentSpec?.assignments?.forEach(assignment => {
      const variantName = getTypeOrNull(assignment.variant?.variant)?.name;
      if (variantName) {
        counts[variantName] = (counts[variantName] ?? 0) + 1;
      }
    });
  });
  return counts;
};

interface VariantItemProps {
  variant: VariantFragment;
  usageCount: number;
}

export const VariantItem = ({ variant, usageCount }: VariantItemProps) => {
  const inUse = usageCount > 0;
  const tagLabel = inUse ? 'In use' : 'Unused';

  return (
    <Flex
      display="flex"
      alignItems="center"
      style={{
        gap: 'var(--bui-space-2)',
      }}
    >
      <Text variant="body2">
        {extractLastNameComponent(variant.name) ?? variant.name}
      </Text>
      <Flex
        display="flex"
        flexWrap="wrap"
        style={{
          gap: 'var(--bui-space-2)',
        }}
        aria-label={`${variant.name} usage`}
      >
        <Tag
          id={variant.name}
          label={tagLabel}
          size="small"
          className={inUse ? styles.usageTagInUse : styles.usageTagUnused}
        />
      </Flex>
    </Flex>
  );
};
